import {PriorityIcon, Icon, Input} from '@priority-software/priority-style-react';
import React from 'react';
import texts from '../texts';
import {createDataTestId} from '../../../utils/dataTestId';

interface Props {
    searchQuery: string;
    onChangeQuery: (value: string) => void;
    inputClasses?: string;
    roundedCorners?: boolean;
    placeholder?: string;
    inputRef?: React.RefObject<HTMLInputElement>;
}
const SearchInput = ({
    searchQuery,
    inputClasses,
    onChangeQuery,
    roundedCorners = false,
    placeholder,
    inputRef
}: Props) => {
    return (
        <Input
            inputRef={inputRef}
            placeholder={placeholder || texts.searchInput}
            value={searchQuery || ''}
            componentClasses={inputClasses}
            onChange={e => onChangeQuery(e.target.value)}
            {...createDataTestId('analytics-search-input', true)}
            roundedCorners={roundedCorners}
            onFocus={e => e.target.select()}
        >
            {searchQuery && (
                <Icon icon={PriorityIcon.closeSmall} onClick={() => onChangeQuery('')} />
            )}
            <Icon icon={PriorityIcon.searchThin} />
        </Input>
    );
};

export default SearchInput;
